import gridHeight from '../core/shared-service/grid-utils';
import templateUrl from './billing-warrants.html';

export const billingWarrants = {
  templateUrl,
  bindings: {
    seller: '<' // Les données du fournisseur.,
  },
  controllerAs: 'ctrl',
  controller: class SubEntities {
    /*@ngInject*/
    constructor($translate, KissSellerSvc, CONF) {
      this.$translate = $translate;
      this.KissSellerSvc = KissSellerSvc;
      this.gridApi = null;
      this.CONF = CONF;
    }

    $onInit() {
      var defaultCellTemplate = '<div  class="ui-grid-cell-contents cursor-default">{{COL_FIELD CUSTOM_FILTERS}}</div>';
      var viewCellTemplate =
        '<div class="ui-grid-cell-contents cursor-default text-center" name="view_billing_warrant"' +
        'ng-if="row.entity.billingWarrantFileId">' +
        '<a href="" ng-href="{{grid.appScope.ctrl.getBillingWarrantLink(row.entity.billingWarrantFileId)}}" target="_blank"><span><i class="fa fa-eye"></i></span>&nbsp;</a></div>';
      this.billingWarrantsGridOptions = {
        columnDefs: [
          {
            name: 'billingWarrantRef',
            displayName: 'kiss_seller.edit.billing_warrants.ref',
            headerCellFilter: 'translate',
            minWidth: '350',
            cellFilter: 'translate',
            cellTemplate: defaultCellTemplate,
            cellClass: 'cursor-default'
          },
          {
            name: 'billingWarrantDate',
            displayName: 'kiss_seller.edit.billing_warrants.date',
            headerCellFilter: 'translate',
            width: '300',
            cellTemplate: defaultCellTemplate,
            cellClass: 'cursor-default',
            cellFilter: 'date:"shortDate"',
            sort: { direction: 'desc', priority: 0 }
          },
          {
            name: 'see',
            displayName: 'kiss_seller.edit.billing_warrants.see',
            headerCellFilter: 'translate',
            enableCellEdit: true,
            width: '150',
            cellTemplate: viewCellTemplate,
            cellClass: 'pointer cursor-default',
            enableSorting: false
          }
        ],
        exporterOlderExcelCompatibility: false,
        useExternalPagination: false,
        useExternalSorting: false,
        onRegisterApi: gridApi => this.onRegisterApi(gridApi),
        enableSorting: true,
        enableGridMenu: false,
        enableRowSelection: false,
        enableColumnMenus: false,
        paginationPageSizes: [5, 10, 20],
        paginationPageSize: 5,
        data: {}
      };

      this.search();
    }

    /** Fournit l'url pour accéder au pdf de la facture. */
    getBillingWarrantLink(billingWarrantFileId) {
      if (billingWarrantFileId) {
        return (
          this.CONF.apiContext + this.CONF.apiBaseUrl + '/v1/files/' + billingWarrantFileId + '?disposition=INLINE'
        );
      }
    }

    onRegisterApi(gridApi) {
      this.gridApi = gridApi;
    }

    getGridHeight() {
      return gridHeight(this.gridApi, this.billingWarrantsGridOptions.rowHeight);
    }

    /**
     * Nous dit si le fichier du mandat de facturation est disponible.
     */
    canViewBillingWarrantFile() {
      return this.seller.legalEntity.idFiscal === null;
    }

    /**
     * Recherche des mandats de facturation.
     */
    search() {
      this.billingWarrantsGridOptions.data = this.KissSellerSvc.getBillingWarrants(this.seller.id).then(
        billingWarrants => {
          this.billingWarrantsGridOptions.data = billingWarrants;
        }
      );
    }
  }
};
